export default "__VITE_PUBLIC_ASSET__356a95a6__"